<div *ngIf="elencoCorsiInHome[0]" class="video-box">
    <div class="image">
        <img src="{{urlImageHD+elencoCorsiInHome[0].image}}" class="shadow" alt="image">
    </div>
    <a routerLink="/dettaglio-corso/{{elencoCorsiInHome[0].tag}}" class="video-btn popup-youtube"><i class="flaticon-play"></i></a>
    <div class="shape10"><img src="assets/img/shape9.png" alt="image"></div>
</div>
